import { BaseComponent } from './BaseComponent';

export const BaseElement = {
  mixins: [BaseComponent],
};
